<script lang="ts">
  import UpdateLeaveRequest from '../../components/employer/leaveRequest/UpdateLeaveRequest.svelte';
  import { params } from 'svelte-spa-router';
  
  $: requestId = ($params?.id as string) || '';
</script>

<UpdateLeaveRequest {requestId} /> 